import React from 'react';

import IconAddFolder from 'common/components/button/svg-icons/add-folder.svg?react';

import RibbonButton from 'common/components/button/RibbonButton';

import Messages from 'i18n/messages/home';

const CreateFolderDetail = (props) => {
  const { setVisibleModal, disabled } = props;

  const openNewFolderModal = () => {
    setVisibleModal(true);
  };

  return (
    <>
      <RibbonButton
        size='small'
        icon={<IconAddFolder />}
        label={Messages.newFolder}
        onClick={openNewFolderModal}
        disabled={disabled}
      />
    </>
  );
};

export default CreateFolderDetail;
